'use client';

import { useState } from 'react';

interface UseLoading {
  isLoading: boolean;
  startLoading(): void;
  stopLoading(): void;
}

export function useLoading(initialValue = false): UseLoading {
  const [isLoading, setIsLoading] = useState<boolean>(initialValue);

  const startLoading = () => setIsLoading(true);
  const stopLoading = () => setIsLoading(false);

  return { isLoading, startLoading, stopLoading };
}
